import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import ClientLogo from "../../components/ClientLogo/ClientLogo";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { Menu, MenuItem } from "@mui/material";
import { useAuth } from "../../auth";
import HomeIcon from "../../assets/Icons/home.svg";
import { useNavigate } from "react-router-dom";
import styles from "./viewReportV2.module.scss";
import ProgressAndAnalysis from "./progressandAnalysis";
import ViewListUserReport from "./ViewListUserReport";
import { getUserDetails } from "../../services/DashboardServices";
import ExpandLessSharpIcon from "@mui/icons-material/ExpandLessSharp";
import ExpandMoreSharpIcon from "@mui/icons-material/ExpandMoreSharp";
import { useOrgContext } from "../../Context/orgContext";
import axios from "axios";
import { authenticateService } from "../../services/CommonService";

const ViewReportV2 = () => {
  // const { sessionId } = useParams();
  const [selectedTab, setSelectedTab] = useState(1);
  const [ showMoreDetails , setShowMoreDetials ] = useState(false);
  const [ patientIntakeDetials , setPatientIntakedetails ] = useState({});
  const [ userFeedbackDetials , setUserFeedbackDetails ] = useState(null);
  const location = useLocation();
  console.log("location", location);
  const { userId } = useParams();
  const queryParams = new URLSearchParams(location.search);
  const activeTab = queryParams.get("activeTab");
  const handleTabClick = (index) => {
    setSelectedTab(index);
  };
  const [anchorEl, setAnchorEl] = React.useState(null);
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const auth = useAuth();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const [userDetails, setUserDetails] = useState({});
  const { orgDetails } = useOrgContext();

  useEffect(() => {
    if (userId) {
      getUserDetails(userId).then((res) => {
        setUserDetails(res.data);
      });
    }
  }, [userId]);
  const handleClose = () => {
    setAnchorEl(null);
    auth.logout();
  };

  useEffect(() => {
    if (activeTab === "reports") {
      setSelectedTab(1);
    }
  }, [activeTab]);

  const getFirstLetter = (name) => {
    return name.charAt(0);
  };

  useEffect(() => {
    (async() => {
      const token = await authenticateService();
      const client = orgDetails.domain_name;
      if (token.jwt) {
        return axios
          .get(
            `/api/v1/endUser/dynamic-form-data/getFormData?end_user_id=${userId}&form_name=${'assessment-patient-Intake-form'}&organisation_domain_name=${client}`,
            {
              headers: {
                Authorization: `Bearer ${token.jwt}`,
              },
            }
          )
          .then((response) => {
            if(response?.data?.data?.forms?.length > 0){
              setPatientIntakedetails(response.data.data.forms[0])
            }
          })
          .catch((error) => {
            return error;
          });
      }
    })()
  } , [ userId, orgDetails ]);

  useEffect(() => {
    (async() => {
      const token = await authenticateService();
      const client = orgDetails.domain_name;
      if (token.jwt) {
        return axios
          .get(
            `/api/v1/endUser/dynamic-form-data/getFormData?end_user_id=${userId}&form_name=${'assessment-feedback-form'}&organisation_domain_name=${client}`,
            {
              headers: {
                Authorization: `Bearer ${token.jwt}`,
              },
            }
          )
          .then((response) => {
            setUserFeedbackDetails(response.data.data.forms[0])
          })
          .catch((error) => {
            return error;
          });
      }
    })()
  } , [ userId, orgDetails ]);

  function getKeysWithYesValueFromObject(obj) {
    if (typeof obj !== 'object' || obj === null || Array.isArray(obj)) {
      throw new Error('Input must be a non-null object');
    }
  
    const keysWithYesValue = [];
  
    for (const key in obj) {
      if (obj[key] === 'yes') {
        keysWithYesValue.push(key);
      }
    }
    const returnValue = keysWithYesValue.length > 0 ? keysWithYesValue.toString() : "-"
    return returnValue;
  }

  const isPatientIntakeDetialsPresent = Object.keys(patientIntakeDetials)?.length > 0;
  return (
    <div className="bg-[#F5F9FF] overflow-auto h-screen">
      <div className="max-w-[1440px] mx-auto my-0">
        <div className="flex justify-between bg-[#E1EDFF] pl-[68px] pr-[84px] items-center pt-6 pb-5">
          <div>
            <ClientLogo customClassName="w-[150px] h-[56px]" />
          </div>
          <div>
            <AccountCircleOutlinedIcon
              sx={{
                height: "30px",
                width: "30px",
                color: "#415280",
              }}
              onClick={handleClick}
            />
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              <MenuItem onClick={handleClose}>Logout</MenuItem>
            </Menu>
          </div>
        </div>
        <div className=" px-[76px]">
          <div className="mt-[74px] mb-3 flex items-center text-[#415280] text-sm leading-[21px] pb-3 border-b border-solid border-[#DADFFF] font-semibold gap-2">
            <div>
              <img
                src={HomeIcon}
                alt=""
                onClick={() => {
                  navigate("/dashboard");
                }}
              />
            </div>
            <div>{">"}</div>
            <div>
              {userDetails && userDetails.username && (
                <span>{userDetails.username}</span>
              )}{" "}
            </div>
          </div>
          
          <div className="flex flex-col">
            <div className={`${ isPatientIntakeDetialsPresent ? "rounded-tl-[10px] rounded-tr-[10px]" : "rounded-[10px] mb-5"} bg-[#fff] p-6 flex items-center`}>
              <div className="min-w-[74px] h-[74px] rounded-[50%] bg-[#E1E1E1] flex justify-center items-center text-[#827F7F] text-3xl font-normal capitalize">
                {userDetails &&
                  userDetails.username &&
                  getFirstLetter(userDetails.username)}
              </div>
              <div className="flex ml-11 w-full">
                <div className="w-1/4">
                  <div className="text-[#000] opacity-50 font-normal text-sm">
                    User name
                  </div>
                  <div className="text-[#415280] font-semibold text-sm ">
                    {userDetails && userDetails.username}
                  </div>
                </div>
                <div className="w-1/4">
                  <div className="text-[#000] opacity-50 font-normal text-sm">
                    E-mail id
                  </div>
                  <div className="text-[#415280] font-semibold text-sm">
                    {userDetails && userDetails.email_id}
                  </div>
                </div>
                <div className="w-1/4">
                  <div className="text-[#000] opacity-50 font-normal text-sm">
                    { isPatientIntakeDetialsPresent ? "Work site location name" : "Total assessments" }
                  </div>
                  <div className="text-[#415280] font-semibold text-sm">
                    { isPatientIntakeDetialsPresent ? patientIntakeDetials.response?.personalInfo?.workSiteLocationName : userDetails && userDetails.total_assessments_taken}
                  </div>
                </div>
                <div className="w-1/4">
                  <div className="text-[#000] opacity-50 font-normal text-sm">
                    { isPatientIntakeDetialsPresent ? "Time at company" : "Time spent"}
                  </div>
                  <div className="text-[#415280] font-semibold text-sm">
                    {/* { isPatientIntakeDetialsPresent ? "2 years, 6 months" : userDetails && userDetails.time_spent} */}
                    { isPatientIntakeDetialsPresent ? `${patientIntakeDetials.response?.personalInfo?.timeAtCompany.year} years, ${patientIntakeDetials.response?.personalInfo?.timeAtCompany.month} months` : userDetails && userDetails.time_spent}
                  </div>
                </div>
              </div>
            </div>
            { orgDetails?.organisation_name === "ATI" && isPatientIntakeDetialsPresent && <div className="flex flex-col">
              { 
              showMoreDetails && 
                <div className="bg-[#fff]">
                  <div className="border-b border-solid border-[#DADFFF]"></div>
                  <div className="p-[2rem]">
                    <div className="flex w-full">
                      <div className="w-[15%] text-[#344054] text-[14px] font-semibold">Medical Details : </div>
                      <div className="w-[85%]">
                        <div className="flex w-full justify-around">
                          <div className="flex gap-4 flex-1 items-center justify-start">
                            <div className="text-[#000] opacity-[0.5] text-[14px]">Age</div>
                            <div className="text-[#415280] text-[14px] font-semibold">{patientIntakeDetials.response.personalInfo.age || "-"}</div>
                          </div>
                          <div className="flex gap-4 flex-1 items-center justify-start">
                            <div className="text-[#000] opacity-[0.5] text-[14px]">Gender</div>
                            <div className="text-[#415280] text-[14px] font-semibold">{patientIntakeDetials.response.personalInfo.gender.value || "-"}</div>
                          </div>
                          <div className="flex gap-4 flex-1 items-center justify-start">
                            <div className="text-[#000] opacity-[0.5] text-[14px]">Height</div>
                            {/* <div className="text-[#415280] text-[14px] font-semibold">5'11 ft.</div> */}
                            <div className="text-[#415280] text-[14px] font-semibold">{patientIntakeDetials.response.height.feet}{patientIntakeDetials.response.height.inch && "`"}{patientIntakeDetials.response.height.inch} ft.</div>
                          </div>
                          <div className="flex gap-4 flex-1 items-center justify-start">
                            <div className="text-[#000] opacity-[0.5] text-[14px]">Weight(lbs)</div>
                            <div className="text-[#415280] text-[14px] font-semibold">{patientIntakeDetials.response?.weight?.lbs || "-"}</div>
                          </div>
                        </div>
                        <div className="border-b border-solid border-[#DADFFF] mt-5 my-5"></div>
                        <div className="w-full flex justify-start">
                          <div className="flex flex-1 flex-col gap-[10px]">
                            <div className="text-[#000] opacity-[0.5] text-[14px]">How would you describe your activity level?</div>
                            <div className="text-[#415280] text-[14px] font-semibold">{patientIntakeDetials.response?.activityLevel}</div>
                          </div>
                          <div className="flex flex-1 flex-col gap-[10px]">
                            <div className="text-[#000] opacity-[0.5] text-[14px]">Have you had previous injury to the following areas that impact your movement or function?</div>
                            <div className="text-[#415280] text-[14px] font-semibold">{getKeysWithYesValueFromObject(patientIntakeDetials?.response?.injuries)}</div>
                          </div>
                        </div>
                        <div className="border-b border-solid border-[#DADFFF] mt-5 my-5"></div>
                        <div className="w-full flex justify-start">
                          <div className="flex flex-1 flex-col gap-[10px]">
                            <div className="text-[#000] opacity-[0.5] text-[14px]">How often do any previously listed injuries still affect you function?</div>
                            <div className="text-[#415280] text-[14px] font-semibold">{patientIntakeDetials.response?.injuryDetails?.injuryImpactFrequency || "-"}</div>
                          </div>
                          <div className="flex flex-1 flex-col gap-[10px]">
                            <div className="text-[#000] opacity-[0.5] text-[14px]">Please explain any injuries that still effects your functions </div>
                            <div className="text-[#415280] text-[14px] font-semibold">{patientIntakeDetials.response?.injuryDetails?.injuryExplanationsssssssss || "-"}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="border-b border-solid border-[#DADFFF] mt-5 my-5"></div>
                    <div className="flex w-full">
                      <div className="w-[15%] text-[#344054] text-[14px] font-semibold">Other Details : </div>
                      <div className="w-[85%] flex">
                        <div className="flex gap-4 flex-1 items-center justify-start">
                            <div className="text-[#000] opacity-[0.5] text-[14px]">Total assessments</div>
                            <div className="text-[#415280] text-[14px] font-semibold">{ userDetails?.total_assessments_taken || "-" }</div>
                        </div>
                        <div className="flex gap-4 flex-1 items-center justify-start">
                            <div className="text-[#000] opacity-[0.5] text-[14px]">Time spent</div>
                            <div className="text-[#415280] text-[14px] font-semibold">{ userDetails?.time_spent || "-" }</div>
                        </div>
                      </div>
                    </div>
                    <div className="border-b border-solid border-[#DADFFF] mt-5 my-5"></div>
                    <div className="flex w-full">
                      <div className="w-[15%] text-[#344054] text-[14px] font-semibold">User Feedback <br /> Details : </div>
                      <div className="w-[85%]">
                        <div className="w-full flex justify-start">
                          <div className="flex flex-1 flex-col gap-[10px]">
                            <div className="text-[#000] opacity-[0.5] text-[14px]">Experience </div>
                            <div className="text-[#415280] text-[14px] font-semibold">{userFeedbackDetials?.response?.experience || "-"}</div>
                          </div>
                          <div className="flex flex-1 flex-col gap-[10px]">
                            <div className="text-[#000] opacity-[0.5] text-[14px]">Pain</div>
                            <div className="text-[#415280] text-[14px] font-semibold">{userFeedbackDetials?.response?.pain || "-"}</div>
                          </div>
                        </div>
                        <div className="border-b border-solid border-[#DADFFF] mt-5 my-5"></div>
                        <div className="w-full flex justify-start">
                          <div className="flex flex-1 flex-col gap-[10px]">
                            <div className="text-[#000] opacity-[0.5] text-[14px]">PainScale</div>
                            <div className="text-[#415280] text-[14px] font-semibold">{patientIntakeDetials.response?.painScale || "-"}</div>
                          </div>
                          <div className="flex flex-1 flex-col gap-[10px]">
                            <div className="text-[#000] opacity-[0.5] text-[14px]">Comments</div>
                            <div className="text-[#415280] text-[14px] font-semibold">{userFeedbackDetials?.response?.comments || "-"}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
              <div className="cursor-pointer w-full flex items-center justify-center font-semibold text-[#344054] text-[14px] bg-[#E1EDFF] py-[10px] rounded-bl-[10px] rounded-br-[10px] mb-[2rem]" onClick={() => setShowMoreDetials(!showMoreDetails)}>{ showMoreDetails ? `Hide details` : `View more details`} { showMoreDetails ? <ExpandLessSharpIcon /> : <ExpandMoreSharpIcon />}</div>
            </div>}
          </div>

          <div className={styles.tabNavigation}>
            <button
              className={`${styles.tabButton} ${
                selectedTab === 1 ? styles.active : ""
              }`}
              onClick={() => {
                handleTabClick(1);
                navigate(`/user-data/${userId}?activeTab=reports`);
              }}
            >
              Reports
            </button>
            <button
              className={`${styles.tabButton} ${
                selectedTab === 0 ? styles.active : ""
              }`}
              onClick={() => {
                handleTabClick(0);
                navigate(`/user-data/${userId}`);
              }}
            >
              Progress & Analysis
            </button>
          </div>

          <div>
            {selectedTab === 0 && <ProgressAndAnalysis />}
            {selectedTab === 1 && <ViewListUserReport />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewReportV2;
